import React from 'react';
import { useConfiguration } from '../../context/ConfigurationContext';

export const Logo = ({ style, width = 72, height = 72 }) => {
  const configuration = useConfiguration();
  const LOGO_SRC = configuration?.LOGO_SRC;

  return <img src={LOGO_SRC} style={style} width={width} height={height} alt="logo" />;
};
